import { render, staticRenderFns } from "./AllocationOfPremiumQuestions.vue?vue&type=template&id=08acd3ec"
import script from "./AllocationOfPremiumQuestions.vue?vue&type=script&lang=js"
export * from "./AllocationOfPremiumQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports